import axios from 'axios';
import sourceUrl, { newSourceUrl } from './Source.api';

const API_BASE_URL = newSourceUrl || 'http://localhost:8080';

// Share API endpoints
const shareAPI = {
  // Create a new shared session
  createSharedSession: async (sessionId, shareData, token) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/v1/share/session`,
        {
          session_id: sessionId,
          title: shareData.title,
          description: shareData.description,
          expires_at: shareData.expires_at,
          share_settings: {
            show_user_info: shareData.share_settings?.show_user_info ?? true,
            show_timestamps: shareData.share_settings?.show_timestamps ?? true,
            show_files: shareData.share_settings?.show_files ?? false
          }
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating shared session:', error);
      throw error;
    }
  },

  // Get shared session by token (public access) - Not currently implemented
  // getSharedSession: async (shareToken) => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/v1/share/${shareToken}`);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error fetching shared session:', error);
  //     throw error;
  //   }
  // },

  // Get shared session data (messages, files, etc.)
  getSharedSessionData: async (shareToken) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/v1/share/${shareToken}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching shared session data:', error);
      throw error;
    }
  },

  // Get user's shared sessions
  getUserShares: async (token, limit = 20, offset = 0) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/v1/share/user/me?limit=${limit}&offset=${offset}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching user shares:', error);
      throw error;
    }
  },

  // Update shared session
  updateSharedSession: async (shareId, updateData, token) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/v1/share/${shareId}`,
        {
          title: updateData.title,
          description: updateData.description,
          expires_at: updateData.expires_at,
          is_active: updateData.is_active,
          share_settings: updateData.share_settings ? {
            show_user_info: updateData.share_settings.show_user_info,
            show_timestamps: updateData.share_settings.show_timestamps,
            show_files: updateData.share_settings.show_files
          } : undefined
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating shared session:', error);
      throw error;
    }
  },

  // Delete shared session
  deleteSharedSession: async (shareId, token) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/v1/share/${shareId}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting shared session:', error);
      throw error;
    }
  },

  // Get share analytics/stats (if needed) - Not currently implemented
  // getShareStats: async (token) => {
  //   try {
  //     const response = await axios.get(
  //       `${API_BASE_URL}/v1/share/stats`,
  //       {
  //         headers: {
  //           'Authorization': `Bearer ${token}`,
  //           'Content-Type': 'application/json'
  //         }
  //       }
  //     );
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error fetching share stats:', error);
  //     throw error;
  //   }
  // }
};

export default shareAPI;